import type { FlowEditorSDK } from '@wix/yoshi-flow-editor';

import {
  COMPONENTS_REF,
  PROFILE_PAGE_BOB_WIDGET_ID,
  SETTINGS_PAGE_BOB_WIDGET_ID,
} from '../../constants';
import {
  E3_PROFILE_PAGE_COMPONENT_REF,
  E3_SETTINGS_PAGE_COMPONENT_REF,
} from '../../constants/components';
import type { ComponentType, Nullable } from '../../types';
import type { E3ComponentType } from '../../types/components';
import { getIsEditor3 } from '../../utils';
import { getComponentsRefs } from '../editor-sdk-wrappers';
import { log } from './monitor';

const getWidgetRef = async (
  editorSDK: FlowEditorSDK,
  widgetId: string,
  componentType: ComponentType,
) => {
  const componentsRefs = await getComponentsRefs(editorSDK, componentType);

  const [widgetRefComp] = componentsRefs.filter((refComp) => {
    const data = refComp?.data as Nullable<{ widgetId: string }>;
    return data?.widgetId === widgetId;
  });

  return widgetRefComp?.compRef ?? null;
};

const getWidgetRefInEditor3 = async (
  editorSDK: FlowEditorSDK,
  componentType: E3ComponentType,
) => (await editorSDK.components.findAllByType('', { componentType }))[0];

export const getProfilePageBobWidgetRef = async (editorSDK: FlowEditorSDK) => {
  const ref = await (() => {
    if (getIsEditor3()) {
      return getWidgetRefInEditor3(editorSDK, E3_PROFILE_PAGE_COMPONENT_REF);
    }
    return getWidgetRef(editorSDK, PROFILE_PAGE_BOB_WIDGET_ID, COMPONENTS_REF);
  })();

  if (ref) {
    return ref;
  }

  log('Member Page widgetRef is missing');
  throw new Error('Member page is missing when expected');
};

export const isProfilePageBobWidgetInstalled = async (
  editorSDK: FlowEditorSDK,
) => {
  return !!(await getProfilePageBobWidgetRef(editorSDK));
};

export const getSettingsPageWidgetRef = async (editorSDK: FlowEditorSDK) => {
  const ref = await (() => {
    if (getIsEditor3()) {
      return getWidgetRefInEditor3(editorSDK, E3_SETTINGS_PAGE_COMPONENT_REF);
    }
    return getWidgetRef(editorSDK, SETTINGS_PAGE_BOB_WIDGET_ID, COMPONENTS_REF);
  })();

  if (ref) {
    return ref;
  }

  log('Settings Page widgetRef is missing');
  throw new Error('Settings page is missing when expected');
};

export const isSettingsPageBobWidgetInstalled = async (
  editorSDK: FlowEditorSDK,
) => {
  return !!(await getSettingsPageWidgetRef(editorSDK));
};
